import React from 'react';

const SVGCircleFilledIn = ({color= "#00863B",
                               className = null,
                               style = null,
                               glow=false,
                               pulse = false }) =>{

    const glowStyling = glow
        ? {boxShadow: `0 0 6px ${color}, inset 0 0 6px ${color}`, borderRadius: "50px"}
        : null;

    const pulseStyling = pulse
        ? {webkitAnimation: "pulse 2s linear 1s infinite"}
        :null;

    let styleObject = {...style,
                       ...glowStyling,
                           ...pulseStyling}

    return(
        <svg x={-10} y={-10} width={25} height={25} fill={color} viewBox="0 0 100 100"
             style={styleObject}>
            <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>
        </svg>
    )
}

export default SVGCircleFilledIn;